// extracted by mini-css-extract-plugin
export default {"price":"Q8-z","priceRow":"R8-z","onSale":"S8-z","msrpLabelPrice":"T8-z","msrpLabel":"U8-z","originalPrice":"V8-z","percentOff":"W8-z"};